import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Row, Card, CardBody, Button } from 'reactstrap';
import { Field, reduxForm, FieldArray } from 'redux-form'
import DropDownSelect from '../Dropdown/index';
import { required } from 'glamor';
import VariablePredefined from './VariablePredefined/index';
// import { formatEditData } from './helper.js';
// import { checkSubmitError, checkZeroValue, checkOne } from '../helper';

const renderMembers = ({ fields, variableFiledTypeDropdown, data, variableFieldKeyDropdown, refreshKeyFields, meta: { error, submitFailed } }) => (
    < ul >
        {
            fields.map((member, index) => (
                < li key={index} >
                    <Row className="d-flex mb-3">
                        <Col sm="12" className="px-2">
                            {/* <div className="d-flex align-items-center text-secondary border radius-5 p-2"> */}
                            <Field
                                component="input"
                                name={`${member}.fieldName`}
                                type="text"
                                placeholder="Field Name"
                                className="p-2 w-100 radius-5 border risk-grade-input"
                                validate={[required]} 
                                onBlur={()=>refreshKeyFields(null)}/>

                            {/* </div> */}
                        </Col>
                        <Col sm="6" className="px-2">
                            <div className="border dropdown-counterparty riskgrade-category-dd">
                                <Field
                                    name={`${member}.fieldType`}
                                    type="text"
                                    component={DropDownSelect}
                                    label="State"
                                    data={variableFiledTypeDropdown}
                                />
                            </div>
                        </Col>
                        {(data) ? (data.values.variableFields[member.match(/\[(.*?)\]/)[1]].fieldType === "NUMERIC") ?
                            <Col sm="5" className="px-2">
                                <div>
                                    <Field
                                        name={`${member}.interpolated`}
                                        id={`${member}.interpolated`}
                                        component="input"
                                        type="checkbox"
                                        style={{ verticalAlign: "middle" }}
                                        className="p-2 radius-5 border risk-grade-input" />
                                    <label htmlFor={`${member}.interpolated`}>Interpolate</label>
                                </div>
                            </Col> : (data.values.variableFields[member.match(/\[(.*?)\]/)[1]].fieldType === "ENUMERATED") ?
                                <Col sm="5" className="px-2">
                                    <div>
                                        <Field
                                            rows="1" cols="50"
                                            component='textarea'
                                            name={`${member}.fieldValue`}
                                            type="text"
                                            placeholder="Value"
                                            className="p-2 w-100 radius-5 border risk-grade-input" />
                                    </div>
                                </Col> : <Col sm="5" className="px-2">
                                    {/* <div className="d-flex align-items-center text-secondary border radius-5 p-2"> */}
                                    <Field
                                        component="input"
                                        name={`${member}.fieldValue`}
                                        type="text"
                                        placeholder=""
                                        disabled
                                        className="p-2 w-100 radius-5 border risk-grade-input" />
                                    {/* </div> */}
                                </Col> : ''
                        }
                        <Col sm="1" className="px-2 text-right"><a onClick={() => { fields.remove(index); refreshKeyFields(data.values.variableFields[member.match(/\[(.*?)\]/)[1]]) }}><i className="icon-close text-danger pointer"></i></a> </Col>
                    </Row>
                </li>
            ))
        }
        < Row >
            <Button type="button" className="d-flex ml-auto text-primary text-decoration-none pr-1" color="link" onClick={() => fields.push({})}><i className="icon-plus mr-2 text-decoration-none"></i>Add More</Button>
        </Row >

    </ul >
)



class VariableFieldsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    componentDidMount() {
        this.props.initialize({
            'variableFields': [{
                fieldName: '',
                fieldType: '',
                fieldValue: '',
                interpolated: false
            }]
        })
    }
    componentDidUpdate(prevProps) {
        if (this.props.variableFieldInitialData !== prevProps.variableFieldInitialData) {
            this.props.initialize({
                variableFields: this.props.variableFieldInitialData
            })
        }
    }
    render() {
        const { error } = this.props
        return (
            <form>
                <Card className="shadow-none">
                    <CardBody>
                        <Row className="mb-1 px-2">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }} className="mb-1">Predefined Fields</span>
                        </Row>
                        <Row className="mb-1">
                            <VariablePredefined predefinedData={this.props.variablePredefinedData} />
                        </Row>
                        <Row className="mb-1 px-2">
                            <span style={{ fontSize: '16px', fontWeight: 'bold' }} className="mb-1">Fields</span>
                        </Row>

                        <Row className="header-blue mb-3">
                            <Col sm="12" className="px-2">Field Name</Col>
                            <Col sm="6" className="px-2">Filed Type</Col>
                            <Col sm="4" className="px-2">Value</Col>
                            {/* <Col sm="4" className="px-2">Key Field</Col> */}
                            <Col sm="" className="px-2"></Col>
                        </Row>
                        <FieldArray name="variableFields" data={this.props.variableFormData} component={renderMembers} variableFiledTypeDropdown={this.props.variableFiledTypeDropdownOptions} variableFieldKeyDropdown={this.props.variableFieldKeyDropdown} refreshKeyFields={this.props.refreshKeyFields} />
                        {/* <FieldArray name="members" fields={this.state.riskGradeBody} component={renderMembers} riskLevels={this.props.riskLevels}/> */}

                    </CardBody>
                </Card>

                <strong className='text-danger mb-5'>{error ? error : ""}</strong>
            </form>
        )
    }
}


const mapStateToProps = (state, ownProps) => ({
    // editdata: state.corporateOnBoardingCreate.editData
    variableFormData: state.form.VariableFieldsForm
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default reduxForm({
    form: 'VariableFieldsForm'
})(connect(mapStateToProps, mapDispatchToProps)(VariableFieldsForm))
